"use client";

import { useEffect, useRef, useState } from "react";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";
import CommonImage from "@/components/common/image/CommonImage";
import CourseCard from "@/components/common/card/CourseCard";
import HomePageService from "@/services/api/HomeService";
import { useSelector } from "react-redux";
import SkeletonCourseSection from "@/components/common/skeletons/SkeletonCourseSection"; 
import { LuChevronRight } from "react-icons/lu";
import dynamic from "next/dynamic";
import Link from "next/link";
import CourseService from "@/services/api/CourseService";
import { usePublicFetch } from "@/hook/usePublicFetch";
const Empty = dynamic(() => import("antd/es/empty"), { ssr: false });
const Spin = dynamic(() => import("antd/es/spin"), { ssr: false });

export default function CourseSection({
  setting,
  groupsResponse = [],
  coursesResponse,
}) {
  const [activeGroup, setActiveGroup] = useState("all");

  const groups = [
    {
      slug: "all",
      title: "সকল কোর্স",
      image: "/images/admission-icon/course-item-1.png",
    },
    ...(groupsResponse?.map((g) => ({
      slug: g.slug,
      title: g.name,
      image: g.icon_url ?? "/images/admission-icon/course-item-2.png",
    })) || []),
    {
      slug: "free",
      title: "ফ্রি কোর্স",
      image: "/images/admission-icon/course-item-5.png",
    },
  ];

  let courses = coursesResponse?.courses || [];
  let selectedGroup = coursesResponse?.group || null;

  if (activeGroup !== "all" && activeGroup !== "free") {
    const groupObj = groupsResponse.find((g) => g.slug === activeGroup);
    if (groupObj) {
      courses = courses.filter((course) =>
        Array.isArray(course.group_id)
          ? course.group_id.includes(groupObj.id.toString())
          : course.group_id?.toString() === groupObj.id.toString()
      );
      selectedGroup = groupObj;
    }
  }

  if (activeGroup === "free") {
    courses =
      coursesResponse?.courses.filter((course) => course.admission_fee === 0) ||
      [];
    selectedGroup = { name: "ফ্রি কোর্স" };
  }
  return (
    <>
      <section className="course_section section_padding">
        <span className="ellipse ellipse-1"></span>
        <span className="ellipse ellipse-2"></span>
        <span className="ellipse ellipse-3"></span>
        <span className="ellipse ellipse-4"></span>
        <div className="container">
          <div className="course-section-card">
            {/* Section Title */}
            {setting && (
              <div className="section_title">
                <h2 className="title">
                  <span className="w-8 h-8">
                    <CommonImage
                      src="/images/admission-icon/book-icon.png"
                      className="img-icon"
                      alt="Book Icon"
                    />
                  </span>{" "}
                  {selectedGroup?.name ?? "সকল কোর্স"}
                </h2>
                <p className="short-des">{setting?.course_sub_title}</p>
              </div>
            )}

            <div className="course_prorams">
              {groups?.map((item, index) => (
                <div
                  key={index}
                  className={`program-item cursor-pointer`}
                  onClick={() => setActiveGroup(item.slug)}
                >
                  <div
                    className={`item-card ${
                      activeGroup == item.slug ? "active" : ""
                    }`}
                  >
                    <div className="program-icon">
                      <CommonImage
                        src={item.image}
                        className="img-icon"
                        alt="Program Icon"
                      />
                    </div>
                    <div className="item-content">
                      <h4 className="title">{item.title}</h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="grid xl:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-3 md:gap-4 lg:gap-6 courses">
              {courses.length > 0 ? (
                courses.slice(0, 6).map((item, index) => {
                  const pattern = [
                    "course-card-one",
                    "course-card-two",
                    "course-card-three",
                  ];
                  const bgClass = pattern[index % pattern.length];

                  return (
                    <CourseCard key={index} course={item} bgClass={bgClass} />
                  );
                })
              ) : (
                <div className="col-span-full">
                  <Empty description="No course available" />
                </div>
              )}
            </div>
            {courses.length > 0 && (
              <div className="mt-8">
                <Link href="/courses/all" className="seemore-btn">
                  আরো দেখুন <LuChevronRight />
                </Link>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
